(function () {
    'use strict';

    angular.module('app.ui')
        .directive('uiFilter', uiFilter);

    function uiFilter() {
        return {
            restrict: 'EA',
            templateUrl: 'views/ui/filter.html',
            scope: {
                values: '=',
                selected: '=',
                action: '=',
                align: '@'
            },
            controller: 'FilterCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();